module.exports = __webpack_public_path__ + "static/media/Services_Insurance.b05fe2c0.svg";